import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { useAppTheme } from '@contexts/ThemeContext';
import packageJson from '../../package.json';

const APP_VERSION = packageJson.version; // Dynamically read from package.json

const Footer: React.FC = () => {
    const { isDarkMode } = useAppTheme();

    return (
        <Box sx={{
            background: isDarkMode
                ? 'linear-gradient(135deg, #1a1a2e 0%, #262b45 100%)'
                : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
            borderTop: isDarkMode
                ? '1px solid rgba(255, 255, 255, 0.1)'
                : '1px solid rgba(0, 0, 0, 0.1)',
            boxShadow: isDarkMode
                ? '0 -4px 20px rgba(0, 0, 0, 0.3)'
                : '0 -4px 20px rgba(0, 0, 0, 0.1)',
            p: { xs: 1.5, sm: 2 },
            width: '100%',
            boxSizing: 'border-box'
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: { xs: 1, sm: 2 }
            }}>
                {/* Left - Contact & Version */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', justifyContent: { xs: 'center', sm: 'flex-start' } }}>
                    <Typography variant="body2" sx={{
                        color: isDarkMode ? 'rgba(255, 255, 255, 0.7)' : 'rgba(26, 26, 46, 0.7)',
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                    }}>
                        📞 +91-9611058522
                    </Typography>
                    <Chip
                        label={`v${APP_VERSION}`}
                        size="small"
                        sx={{
                            height: '20px',
                            fontSize: '0.7rem',
                            fontWeight: 600,
                            bgcolor: isDarkMode ? 'rgba(102, 126, 234, 0.2)' : 'rgba(102, 126, 234, 0.1)',
                            color: isDarkMode ? '#90caf9' : '#667eea',
                            border: isDarkMode ? '1px solid rgba(144, 202, 249, 0.3)' : '1px solid rgba(102, 126, 234, 0.3)',
                        }}
                    />
                </Box>

                {/* Center - Email */}
                <Typography variant="body2" sx={{
                    color: isDarkMode ? 'rgba(255, 255, 255, 0.7)' : 'rgba(26, 26, 46, 0.7)',
                    fontSize: { xs: '0.75rem', sm: '0.875rem' }
                }}>
                    info@multiplierskraft.com
                </Typography>

                {/* Right - Links */}
                <Box sx={{
                    display: 'flex',
                    gap: { xs: 1, sm: 2 }
                }}>
                    <Typography variant="body2" sx={{
                        color: isDarkMode ? 'rgba(255, 255, 255, 0.7)' : 'rgba(26, 26, 46, 0.7)',
                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                        cursor: 'pointer',
                        '&:hover': { color: '#667eea' }
                    }}>
                        Privacy
                    </Typography>
                    <Typography variant="body2" sx={{
                        color: isDarkMode ? 'rgba(255, 255, 255, 0.7)' : 'rgba(26, 26, 46, 0.7)',
                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                        cursor: 'pointer',
                        '&:hover': { color: '#667eea' }
                    }}>
                        Terms
                    </Typography>
                    <Typography variant="body2" sx={{
                        color: isDarkMode ? 'rgba(255, 255, 255, 0.7)' : 'rgba(26, 26, 46, 0.7)',
                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                        cursor: 'pointer',
                        '&:hover': { color: '#667eea' }
                    }}>
                        Help
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default Footer;


